import api from 'services/api';
import action from 'utils/action';
import checkError from 'utils/check-error';

export function projectSystemDefinitionFind(id) {
  return (dispatch) => {
    dispatch(action('PROJECT_DEFINITION_GET_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get(`/api/projects/${id}/definition`)
      .then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_DEFINITION_GET_FAILURE', payload.json));
          reject(payload.json);
        } else {
          dispatch(action('PROJECT_DEFINITION_GET_SUCCESS', payload.json));
          resolve(payload.json);
        }
      })
      .catch((payload) => {
        dispatch(action('PROJECT_DEFINITION_GET_FAILURE', payload.json));
        reject(payload.json);
      });
    });
  };
}

export function projectSystemDefinitionFindProducts(id) {
  return (dispatch) => {
    dispatch(action('PROJECT_SYSTEM_PRODUCTS_GET_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get(`/api/projects/${id}/system-products`)
      .then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_SYSTEM_PRODUCTS_GET_FAILURE', payload.json));
          reject(payload.json);
        } else {
          dispatch(action('PROJECT_SYSTEM_PRODUCTS_GET_SUCCESS', payload.json));
          resolve(payload.json);
        }
      })
      .catch((payload) => {
        dispatch(action('PROJECT_SYSTEM_PRODUCTS_GET_FAILURE', payload.json));
        reject(payload.json);
      });
    });
  };
}

export function projectSystemDefinitionPatchProduct(projectId, productType, data) {
  return (dispatch) => {
    dispatch(action('PROJECT_DEFINITION_PATCH_REQUEST'));

    return new Promise((resolve, reject) => {
      let payload = data;
      if (payload && !payload.data) {
        if (payload.attributes) {
          payload = { data: payload };
        } else {
          payload = { data: { attributes: payload } };
        }
      }

      api.patch(`/api/projects/${projectId}/${productType}`, payload).then((response) => {
        if (checkError(response)) {
          dispatch(action('PROJECT_DEFINITION_PATCH_FAILURE', response.json));
          reject(response.json);
        } else {
          dispatch(action('PROJECT_DEFINITION_PATCH_SUCCESS', response.json));
          resolve(response.json);
        }
      }).catch((error) => {
        dispatch(action('PROJECT_DEFINITION_PATCH_FAILURE', error));
        reject();
      });
    });
  };
}

export function projectSystemDefinitionDeleteProduct(projectId, productType) {
  return (dispatch) => {
    dispatch(action('PROJECT_DEFINITION_DELETE_REQUEST'));

    return new Promise((resolve, reject) => {
      api.delete(`/api/projects/${projectId}/${productType}`).then((response) => {
        if (checkError(response)) {
          dispatch(action('PROJECT_DEFINITION_DELETE_FAILURE', response.json));
          reject(response.json);
        } else {
          dispatch(action('PROJECT_DEFINITION_DELETE_SUCCESS', response.json));
          resolve(response.json);
        }
      }).catch((error) => {
        dispatch(action('PROJECT_DEFINITION_DELETE_FAILURE', error));
        reject();
      });
    });
  };
}

export function projectSystemDefinitionUpdateControls(projectId, payload, systemDefinition) {
  return (dispatch) => {
    dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_CONTROLS_REQUEST'));
    return new Promise((resolve, reject) => {
      api.patch(`/api/projects/${projectId}/set-controls`, payload).then((response) => {
        const responseJSON = response.json;
        if (checkError(response)) {
          dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_CONTROLS_FAILURE', { systemDefinition, response: responseJSON }));
          reject(response.json);
        } else {
          dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_CONTROLS_SUCCESS', { systemDefinition, response: responseJSON }));
          resolve(response.json);
        }
      }).catch((error) => {
        dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_CONTROLS_FAILURE', error));
        reject();
      });
    });
  };
}

export function projectSystemDefinitionUpdateHydraulics(projectId, payload, systemDefinition) {
  return (dispatch) => {
    dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_HYDRAULICS_REQUEST'));
    return new Promise((resolve, reject) => {
      api.patch(`/api/projects/${projectId}/set-hydraulics`, payload).then((response) => {
        const responseJSON = response.json;
        if (checkError(response)) {
          dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_HYDRAULICS_FAILURE', { systemDefinition, response: responseJSON }));
          reject(response.json);
        } else {
          dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_HYDRAULICS_SUCCESS', { systemDefinition, response: responseJSON }));
          resolve(response.json);
        }
      }).catch((error) => {
        dispatch(action('PROJECT_SYSTEM_DEFINITION_UPDATE_HYDRAULICS_FAILURE', error));
        reject();
      });
    });
  };
}



// WEBPACK FOOTER //
// ./js/actions/project-system.js